import React, { useEffect, useRef } from 'react';
import { useTheme } from '../utils/theme';

const TradeView = ({ symbol }) => {
  const container = useRef(null);
  const { mode } = useTheme();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/tv.js';
    script.async = true;
    script.onload = () => {
      if (typeof TradingView !== 'undefined') {
        new TradingView.widget({
          autosize: true,
          width: '100%',
          height: '100%',
          symbol: symbol,
          interval: 'D',
          timezone: 'Etc/UTC',
          theme: mode === 'dark' ? 'dark' : 'light',
          style: '3',
          locale: 'en',
          toolbar_bg: mode === 'dark' ? '#161f2e' : '#f1f3f6',
          enable_publishing: false,
          allow_symbol_change: true,
          container_id: 'tradingview_advanced',
        });
      }
    };
    container.current.appendChild(script);

    return () => {
      if (container.current) {
        container.current.removeChild(script);
      }
      // Drop the old widget iframe so a theme/symbol change rebuilds cleanly
      const widgetHost = document.getElementById('tradingview_advanced');
      if (widgetHost) {
        widgetHost.innerHTML = '';
      }
    };
  }, [symbol, mode]);

  return (
    <div className="tradingview-advanced-container" ref={container}>
      <div id="tradingview_advanced"></div>
    </div>
  );
};

export default TradeView;
